import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Swedish
    return localStorage.getItem('preferred-language') || 'sv';
  });

  const setLanguagePersistent = (lang) => {
    localStorage.setItem('preferred-language', lang);
    setLanguage(lang);
  };

  const value = {
    language,
    setLanguage: setLanguagePersistent,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};